export const TRAVEL_CAR_HIRE_SUB_BOOKING_LOCAL_STORAGE_KEY = 'app_travel_car_hire_sub_booking';
export const TRAVEL_FLIGHT_SUB_BOOKING_LOCAL_STORAGE_KEY = 'app_travel_flight_sub_booking';
export const TRAVEL_HOTEL_SUB_BOOKING_LOCAL_STORAGE_KEY = 'app_travel_hotel_sub_booking';
export const TRAVEL_BOOKING_TRACKING_PARAMS = 'booking_tracking_params';
export const TRAVEL_HOTEL_SEARCH_LOCAL_STORAGE_KEY = 'app_hotel_search';
export const TRAVEL_HOTEL_DETAILS_LOCAL_STORAGE_KEY = 'app_hotel_details';
export const TRAVEL_HOTEL_MEAL_BASIS = 'app_hotel_meal_basis';
export const TRAVEL_HOTEL_SUPPLIERS = 'app_hotel_suppliers';
export const TRAVEL_CAR_SEARCH_LOCAL_STORAGE_KEY = 'app_car_search';
export const TRAVEL_FLIGHT_SEARCH_LOCAL_STORAGE_KEY = 'app_flight_search';
export const TRAVEL_FLIGHT_SEARCH_RESULTS_LOCAL_STORAGE_KEY = 'app_flight_search_results';
export const TRAVEL_SELECTED_FLIGHT_LOCAL_STORAGE_KEY = 'app_travel_selected_flight';
export const TRAVEL_SELECTED_FARE_FAMILY_LOCAL_STORAGE_KEY = 'app_travel_selected_fare_family';
export const USER_ACCESS_TOKEN_REFRESH_INTERVAL = 264000; // 4.4 mins
export const USER_LOCAL_STORAGE_KEY = 'app_user';
export const SELECTED_HOTEL_LOCAL_STORAGE_KEY = 'app_selected_hotel';
export const SELECTED_ROOM_LOCAL_STORAGE_KEY = 'app_selected_room';
export const ROOMS_LOCAL_STORAGE_KEY = 'app_hotel_rooms';
export const ROOM_SEQ_NR = 'app_room_seq_nr';
export const SELECTED_HOTEL_MAIN_IMAGE = 'hotel_main_image';
export const HOTEL_SEARCH_RESULTS = 'app_hotel_search_results';
export const HOTEL_SUB_BOOKING = 'hotel_sub_booking';
export const BOOKING_HOTEL_ADYEN_INSTALMENT_ENABLED = 'app_booking_adyen_instalment_enabled';
export const TRAVEL_BOOKING_PROGRESS_BAR_LOCAL_STORAGE_KEY = 'app_travel_booking_progress_bar';
export const BOOKING_HERO_IMAGE_LOCAL_STORAGE_KEY = 'booking_hero_image';
export const SELECTED_TRAVELERS = 'selected_travelers';
export const RESTAURANT_DETAIL_PAGE = 'restaurant_detail_page';
export const TRAVEL_SEARCH_TOGGLES_LOCAL_STORAGE_KEY = 'app_travel_search_toggles';
export const COUNTRY_FLAG_IMAGE_URL = 'https://restcountries.eu/data/';
export const THREEDS_BOOKING_KEY = 'threeds_booking';
export const DINING_SEARCH = 'dining_search';
export const CAR_SEARCH_REFERENCE_ID = 'car_search_reference_id';
export const SELECTED_CAR = 'selected_car';
export const DINING_LAYOUT = 'dining_layout';
export const HOTEL_LAYOUT = 'hotel_layout';
export const MAP_RESULT_LAST_ITEM = 'map_result_last_item';
export const ALL_AIRLINES = 'all_airlines';
export const FLIGHT_CLASSES = 'flight_classes';
export const OFFERS_PROMO_BANNER_CLOSED = 'offers_promo_banner_closed';
export const WELCOME_VIDEO_SHOWN = 'welcomeVideoShown';
export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoidGVuZ3JvdXAiLCJhIjoiY2w5cXhzYTg3MGV5YzQycXI1aXo5aHM1dyJ9.g5W4HKAZ8_XOWnlJlN4ItQ';
export const PREFERENCES_POPUP_SHOWN = 'preferencesPopupShown';
export const ARTIST_POPUP_SHOWN = 'artistPopupShown';
export const USER_SELECTED_SITE = 'userSelectedSite';
export const AVAILABILITY_FORM_KEY = 'availability_form';
export const AVAILABILITY_PREBOOK_DETAILS = 'availability_prebook_details';
export const ACTIVITIES_STATE = 'activities_state';
export const REQUEST_MANAGEMENT_STATE = 'request_management_state';
export const REQUEST_MANAGEMENT_REQUEST_TYPES = 'request_management_request_types';
export const ENTERTAINMENT_TICKET_BOOK_TOKEN = 'bookToken';
export const ACTIVITIES_FORM_KEY = 'activities_form';
export const HOTEL_FILTER_FORM = 'hotel_filter_form';
export const AMENITIES_EXPANDED = 'hotel_amenities_expanded';
